import React from 'react';
import { Circle, Diamond, Star } from 'lucide-react';
import { getTierKind } from '../featureModels';

export default function TierBadge({ tier, size = 'sm' }) {
  const kind = getTierKind(tier);
  const label = kind === 'verified' ? 'Verified tier' : kind === 'premium' ? 'Premium tier' : 'Base tier';
  const Icon = kind === 'verified' ? Star : kind === 'premium' ? Circle : Diamond;
  const iconSize = size === 'md' ? 16 : 12;

  return (
    <span className={`ic-tier-badge ic-tier-${kind} ${size === 'md' ? 'is-md' : ''}`} title={label} aria-label={label}>
      <Icon size={iconSize} strokeWidth={1.8} fill={kind === 'verified' ? 'currentColor' : 'none'} aria-hidden="true" />
    </span>
  );
}
